<div class="container-fluid spacer-top-navigation savings-plan">
  <div class="container">
    <div class="row mb-3">
      <div class="col-12">
        <h1 class="zero-text p-huge-med">{{ 'statistics.headline' | transloco }} (BETA)</h1>
      </div>
    </div>

    <div class="row same-height mb-lg-4">
      <div class="col-lg-8 mb-4 mb-lg-0">
        <statistics-my-chart
          [chartWithCash]="facade.myChartWithCash$ | async"
          [chartWithoutCash]="facade.myChartWithoutCash$ | async"
          [accountTotal]="(facade.performance$ | async)?.currentValue"
          [cashTotal]="(facade.myStats$ | async)?.cashTotal"
          [loading]="facade.myChartAndStatsLoading$ | async"
          (changePeriod)="facade.changeChartPeriod($event)"
        />
      </div>
      <div class="col-lg-4 mb-4 mb-lg-0">
        <statistics-my-stats
          [stats]="facade.myStats$ | async"
          [accountTotal]="(facade.performance$ | async)?.currentValue"
          [loading]="facade.myChartAndStatsLoading$ | async"
        />
      </div>
    </div>

    <div class="row same-height mb-lg-4">
      <div class="col-lg-4 mb-4 mb-lg-0">
        <statistics-my-trades [myTrades]="facade.myTrades$ | async" [loading]="facade.myTradesLoading$ | async" />
      </div>
      <div class="col-lg-4 mb-4 mb-lg-0">
        <statistics-weighting
          [weighting]="facade.weighting$ | async"
          [type]="facade.weightingType$ | async"
          [loading]="facade.weightingLoading$ | async"
          (weightingTypeChange)="facade.loadWeighting($event)"
        />
      </div>
      <div class="col-lg-4 mb-4 mb-lg-0">
        <statistics-my-news [news]="facade.myNews$ | async" [loading]="facade.myNewsLoading$ | async" />
      </div>
    </div>

    <div class="row mb-4">
      <div class="col-12">
        <statistics-dividends [dividends]="facade.dividends$ | async" />
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <statistics-trade-ticker
          [trades]="facade.tradeTicker$ | async"
          [filter]="facade.tradeTickerFilter$ | async"
          [loading]="facade.tradeTickerLoading$ | async"
          (filterChange)="facade.toggleTradeTickerFilter($event)"
        />
      </div>
    </div>
  </div>
</div>
